if (!customElements.get('fg-guide-library')) {
  customElements.define('fg-guide-library', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.items = Array.from(this.querySelectorAll('[data-guide-item]'));
      this.pageSize = Number(this.dataset.pageSize) || 9;
      this.visibleCount = this.pageSize;
      this.topic = '';
      this.heading = this.querySelector('.fg-heading');
      this.defaultHeading = this.heading?.textContent || '';
      this.query = new URL(window.location.href).searchParams.get('q') || '';
      this.input = this.querySelector('[data-guide-query]');
      if (this.input) {
        this.input.value = this.query;
        this.input.addEventListener('input', () => {
          this.query = this.input.value;
          this.visibleCount = this.pageSize;
          this.render();
        });
      }
      this.querySelectorAll('.fg-topic-controls,.fg-library-search').forEach(el => { el.hidden = false; });
      this.refreshTopics();
      this.querySelector('.fg-topics')?.addEventListener('click', event => {
        const button = event.target.closest('button[data-topic]');
        if (!button) return;
        this.topic = button.dataset.topic;
        this.visibleCount = this.pageSize;
        this.render();
      });
      this.more = this.querySelector('[data-load-more]');
      this.more.addEventListener('click', () => {
        const previous = this.visibleCount;
        this.visibleCount += this.pageSize;
        this.render();
        this.matches[previous]?.querySelector('a')?.focus({ preventScroll: true });
      });
      this.render();
      this.loadRemaining();
    }
    refreshTopics() {
      if (this.dataset.source !== 'blog') return;
      const row = this.querySelector('.fg-topics');
      if (!row) return;
      row.querySelectorAll('button[data-topic]').forEach(button => { if (button.dataset.topic) button.remove(); });
      const topics = new Set(this.items.flatMap(item => JSON.parse(item.dataset.topics || '[]')).filter(Boolean));
      [...topics].sort().forEach(topic => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.topic = topic;
        button.textContent = topic;
        button.setAttribute('aria-pressed', String(this.topic === topic));
        row.append(button);
      });
    }
    async loadRemaining() {
      let link = this.querySelector('[data-guide-next]');
      const visited = new Set();
      while (link && !visited.has(link.href)) {
        visited.add(link.href);
        try {
          const response = await fetch(link.href);
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const library = doc.querySelector('fg-guide-library');
          if (!library) return;
          const grid = this.querySelector('.fg-grid');
          library.querySelectorAll('[data-guide-item]').forEach(item => grid.append(item));
          const next = library.querySelector('[data-guide-next]');
          link.remove();
          if (next) grid.append(next);
          link = next;
          this.items = Array.from(this.querySelectorAll('[data-guide-item]'));
          this.refreshTopics();
          this.render();
        } catch { return; }
      }
    }
    render() {
      if (this.heading) this.heading.textContent = this.topic || this.defaultHeading;
      const words = this.query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      this.matches = this.items.filter(item => (!this.topic || (item.dataset.topics ? JSON.parse(item.dataset.topics).includes(this.topic) : item.dataset.topic === this.topic)) && words.every(word => item.dataset.search.toLocaleLowerCase().includes(word)));
      const shown = new Set(this.matches.slice(0, this.visibleCount));
      this.items.forEach(item => { item.hidden = !shown.has(item); });
      this.querySelectorAll('button[data-topic]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topic === this.topic)));
      this.more.hidden = this.matches.length <= this.visibleCount;
      this.querySelector('[data-no-results]').hidden = this.matches.length > 0;
      const status = this.querySelector('[data-count-label]');
      status.textContent = `${this.matches.length} ${status.dataset.countLabel}`;
    }
  });
}
